// extracted by mini-css-extract-plugin
export var alertContent = "index-module--alertContent--4f60d flex-1";
export var alertDismissButton = "index-module--alertDismissButton--7c1db text-inherit hover_opacity-70";
export var alertDismissIcon = "index-module--alertDismissIcon--32a7b w-4 h-4";
export var alertItem = "index-module--alertItem--46756 flex items-start justify-between gap-4 p-4 rounded shadow-md border-l-4";
export var alertMessage = "index-module--alertMessage--0d4ed text-sm";
export var alertStackContainer = "index-module--alertStackContainer--889bf fixed top-5 right-5 z-50 space-y-3 w-full";
export var alertTitle = "index-module--alertTitle--b3e63 font-medium";